export const MAX_PROFILE_FILE_SIZE_BYTES = 100 * 1024 * 1024;
export const MAX_PROFILE_FILES = 20;

export const PROFILE_FILE_ACCEPT = {
  'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg', '.bmp', '.tif', '.tiff'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'text/plain': ['.txt'],
  'text/csv': ['.csv'],
  'application/rtf': ['.rtf'],
  'text/rtf': ['.rtf'],
};

export const PROFILE_FILE_TYPES_LABEL =
  'Up to 20 files, 100 MB each. Supports PDF, Word, PPT, XLS, CSV, Text, images and most other common document formats. Video is not supported.';

export const BUILD_FILE_PRIVACY_TOOLTIP =
  'Your sources are only used by TechXpander to understand your business and build your Company Profile. They are not shared directly with Lead Agents. After your profile is built, you can choose which files, if any, you want to share with them. You stay in control.';

export const UPDATE_FILE_PRIVACY_TOOLTIP =
  'Your sources are used by TechXpander to understand your business and keep your Company Profile up to date. Lead Agents cannot access the original source unless you choose to share it. You can change this at any time.';

export const WEB_RESEARCH_TOOLTIP =
  'Allow TechXpander to use relevant public information from trusted websites to supplement your sources and keep your Company Profile more complete and up to date';

export const BUILD_INTRO_TEXT =
  'Create your Company Profile so TechXpander understands your company, products, customers and GTM. This helps you activate more Lead Agents, get them up to speed faster, and create stronger introductions and replies while reducing onboarding and support.';

export const UPDATE_INTRO_TEXT =
  'Your Company Profile is live and helping Lead Agents get up to speed faster and create stronger introductions and replies. Keep it current by adding or updating information anytime.';

export const BUILD_SOURCES_SUBTITLE =
  'Upload the material you already use to explain your business, such as decks, product information, case studies etc. Add relevant webpages too. Start with what you have. You can add more later.';

export const UPDATE_SOURCES_SUBTITLE =
  'Manage the documents and URLs TechXpander uses to keep your Company Profile accurate and up to date. You can also choose which sources Lead Agents can access directly.';

export const UPDATE_SOURCES_SHARING_TOOLTIP_TITLE = 'Sharing with Lead Agents';

export const UPDATE_SOURCES_SHARING_TOOLTIP_BODY = [
  '"Shared" means Lead Agents can open the original document or URL directly.',
  '"Not shared" means they cannot access the source, but TechXpander can still use it to keep your Company Profile up to date.',
  'You can change this at any time.',
];

export const HOW_THIS_WORKS_SECTIONS = [
  {
    title: 'We learn your business',
    body: 'TechXpander uses the information you provide to build structured knowledge about your company, products, customers and GTM.',
  },
  {
    title: 'Lead Agents get better support',
    body: 'The AI uses this knowledge to help Lead Agents get up to speed, create introductions and handle replies, without repeated onboarding.',
  },
  {
    title: 'Your source material stays private',
    body: 'Your documents and URLs are not shared with Lead Agents. After building your profile, you can choose to share specific files with them. Everything else stays private.',
  },
  {
    title: 'You stay in control',
    body: 'Review and edit your Company Profile, add or remove sources, and keep it up to date whenever things change.',
  },
];

export const GTM_DOCTRINE_ITEMS = [
  'Messaging approach',
  'Proof points to use',
  'How to position vs. competitors',
  'Objections & how to address them',
  'CTA and next steps',
  'Language / claims to avoid',
  'Other GTM rules',
];

export const BUILD_WORKFLOW_STEPS = [
  {
    title: 'You provide documents & URLs',
    icon: 'upload',
  },
  {
    title: 'We create all information',
    icon: 'sparkle',
  },
  {
    title: 'You review and keep it up to date',
    icon: 'eye',
  },
];

export const SOURCE_LIST_MAX_HEIGHT = 220;
